module.exports = __webpack_public_path__ + "za.36eedd4dfce7ad655005.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/flag-icon-css/flags/za.svg
// module id = ../../../../../theme/scss/icons/flag-icon-css/flags/za.svg
// module chunks = styles